export default __webpack_public_path__ + "assets/mdi-cart-check.b4400f92.webp";